import { render, staticRenderFns } from "./SubscribeInput.vue?vue&type=template&id=50bf7b2a&lang=pug&"
import script from "./SubscribeInput.vue?vue&type=script&lang=js&"
export * from "./SubscribeInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports